import { ROUTE_CHECKOUT } from '../constants';
import {
  buildCheckoutStartedPayload,
  type CheckoutStartedOrderAmount,
} from '../helpers/brazeHelper';
import { withItemsPayload } from './pulseItemsPayload';
import { trackImmediate } from './pulseTracker';
import type { PulseEventPartial } from './pulseSchema';
import { PULSE_VIEW_ID } from './pulseViewIds';
import { buildCheckoutId, rememberCheckoutIdForCart } from './pulseCheckoutId';

export const buildStartCheckoutPulsePartial = (
  cart: any,
  orderAmount: CheckoutStartedOrderAmount,
  isItMobile: boolean,
  slotDetails: any,
  page_path?: string
): PulseEventPartial => {
  const checkoutStartedPayload = buildCheckoutStartedPayload(
    cart,
    orderAmount,
    isItMobile,
    slotDetails
  );

  const deliveryFee = Number(checkoutStartedPayload.deliveryFee ?? 0);
  const serviceFee = Number(checkoutStartedPayload.serviceFee ?? 0);
  const {
    tax: _tax,
    deliveryFee: _deliveryFee,
    serviceFee: _serviceFee,
    ...brazePayload
  } = checkoutStartedPayload;
  const cartId = checkoutStartedPayload.cartId ?? null;
  const checkout_id = buildCheckoutId(cartId);
  rememberCheckoutIdForCart(cartId, checkout_id);

  return {
    event_name: 'start_checkout',
    view_id: PULSE_VIEW_ID.CHECKOUT,
    page_path:
      page_path ??
      (typeof window !== 'undefined'
        ? window.location.pathname
        : ROUTE_CHECKOUT),
    cart_id: cartId,
    checkout_id,
    sub_total_amount: checkoutStartedPayload.subtotal ?? null,
    transaction_amount: checkoutStartedPayload.subtotal ?? null,
    delivery_amount: deliveryFee > 0 ? deliveryFee : null,
    service_amount: serviceFee > 0 ? serviceFee : null,
    tax_amount: null,
    tip: null,
    ...withItemsPayload(brazePayload),
    action: 'start_checkout',
  };
};

/** Pulse `start_checkout` — immediate send (not batched); fail → retry queue. */
export const trackStartCheckout = (
  cart: any,
  orderAmount: CheckoutStartedOrderAmount,
  isItMobile: boolean,
  slotDetails: any,
  page_path?: string
): void => {
  trackImmediate(
    buildStartCheckoutPulsePartial(
      cart,
      orderAmount,
      isItMobile,
      slotDetails,
      page_path
    )
  );
};
